import { KeycloakConfig, KeycloakInitOptions } from 'keycloak-js';
import {environment} from "../../../environments/environment";

export const keycloakConfig: KeycloakConfig = {
    url: environment.auth.authority,
    realm: environment.auth.realm,
    clientId: environment.auth.clientId,
};

export const keycloakInitOptions: KeycloakInitOptions = {
    onLoad: 'login-required',
    pkceMethod: 'S256',
    checkLoginIframe: false,
};
